module.exports = __webpack_public_path__ + "img/title8.ee69995c.png";